import { reducer, on } from "ts-action";
import { StoreWorkingHours } from "../../../../../../types/Manager/index";
import {
  clearWorkingHoursSchedule,
  getStoreWorkingHours,
  getStoreWorkingHoursFailure,
  getStoreWorkingHoursSuccess,
  setStoreFormChanged,
  updateStoreWorkingHoursSuccess,
} from "../../../actions/Manager";

type IState = StoreWorkingHours & {
  isLoading: boolean;
  error: Error | null;
  storeFormChanged: boolean;
};

const initialState: IState = {
  delivery_intervals: [],
  pickup_intervals: [],
  drive_thru_intervals: [],
  isLoading: false,
  error: null,
  storeFormChanged: false,
};

export const getStoreWorkingHoursReducer = reducer<IState>(
  [
    on(getStoreWorkingHours, (state) => ({
      ...state,
      isLoading: true,
      error: null,
    })),
    on(getStoreWorkingHoursSuccess, (state, { payload }) => ({
      ...state,
      pickup_intervals: payload.pickup_intervals ?? [],
      delivery_intervals: payload.delivery_intervals ?? [],
      drive_thru_intervals: payload.drive_thru_intervals ?? [],
      isLoading: false,
      error: null,
    })),
    on(getStoreWorkingHoursFailure, (state, { payload }) => ({
      ...state,
      isLoading: false,
      error: payload,
    })),
    on(updateStoreWorkingHoursSuccess, (state, { payload }) => ({
      ...state,
      pickup_intervals: payload.pickup_intervals ?? [],
      delivery_intervals: payload.delivery_intervals ?? [],
      drive_thru_intervals: payload.drive_thru_intervals ?? [],
    })),
    on(setStoreFormChanged, (state, { payload }) => ({
      ...state,
      storeFormChanged: payload,
    })),
    on(clearWorkingHoursSchedule, () => initialState),
  ],
  initialState
);
